export default __webpack_public_path__ + "static/media/user-account-settings.f5b797b3.svg";